import { vResizeObserver, vIntersectionObserver } from '@vueuse/components';
import fr from 'date-fns/locale/fr'

import { webComponents, type PluginOptions } from "@tolemac/web-components"

export default defineNuxtPlugin(app => {
    app.vueApp.use(webComponents, {
        formatter: {
            dateLocale: fr
        },
        dev: import.meta.dev,
        register: [
            't-button',
            't-button-icon',
            't-input',
            't-input-number',
            't-input-search',
            't-input-password',
            't-input-email',
            't-input-tel',
            't-input-duration',
            't-datetime',
            't-dropdown',
            't-select',
            't-switch',
            't-checkboxes',
            't-checkbox'
        ]
    } as PluginOptions)

    app.vueApp.directive('resizeObserver', vResizeObserver)
    app.vueApp.directive('intersectionObserver', vIntersectionObserver)
    
})